export default "__VITE_PUBLIC_ASSET__ba3d6830__"